export const IndicatorDot = ({
  color,
}: {
  color: 'green' | 'red' | 'blue' | '' | undefined | null;
}) => {
  if (color === undefined || color === null) {
    return null;
  }

  return (
    <div
      style={{
        width: '12px',
        height: '12px',
        borderRadius: '50%',
      }}
      className={`bg-${color}-500`}
    ></div>
  );
};
